import React from 'react';
import './HeroBanner.css';
import leafLeft from '../components/assets/images/ban-leafleft.png';
import leafRight from '../components/assets/images/ban-leafright.png';
import slider1 from '../components/assets/images/ban-head-Image.png';
import slider2 from '../components/assets/images/ban-head-Image.png';

const HeroBanner = () => {
    return (
        <section className="hero-banner">
            {/* Decorative Leaves */}
            <img src={leafLeft} alt="Leaf Left" className="leaf-left animated-leaf" />
            <img src={leafRight} alt="leaf right" className="leaf-right animated-leaf" />

            {/* Text Section */}
            <div className="hero-text">
                <h1>
                    The Power of the Mountains in Every <br />Drop of
                    <span className="highlight"> Pure Shilajit</span>
                </h1>
                <p>
                    Experience the power of nature with every drop of pure Shilajit — sourced from the Himalayas, lab-tested for purity, and crafted to boost energy, strength, and overall wellness naturally.
                </p>

                <a href="/shilajit" className="promo-btn">
                    Shop Now &raquo;
                </a>
            </div>

            {/* Slider Section */}
            <div className="hero-slider">
                <div className="slider-inner">
                    <img src={slider1} alt="product 1" />
                    <img src={slider2} alt="product 2" />
                    {/* Add more as needed */}
                </div>
            </div>
        </section>
    );
};

export default HeroBanner;
